import React from "react";
import { Link } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbLink,
  BreadcrumbSep,
  BreadcrumbCurrent,
} from "./Breadcrumbs.styles";

// ─── Home Icon ────────────────────────────────────────────────────────────────

const HomeIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3.5 10.5L12 3.5l8.5 7" />
    <path d="M5.5 9.5V20.5H18.5V9.5" />
    <path d="M9.5 20.5V14H14.5V20.5" />
  </svg>
);

// ─── Breadcrumbs ──────────────────────────────────────────────────────────────

const Breadcrumbs = ({ items = [] }) => {
  if (!items.length) {
    return null;
  }

  return (
    <Breadcrumb aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isHome = index === 0 && item.path === "/";

        return (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 && (
              <BreadcrumbSep aria-hidden="true">
                ›
              </BreadcrumbSep>
            )}

            {isLast || !item.path ? (
              <BreadcrumbCurrent aria-current="page">
                {isHome && <HomeIcon />}
                {item.label}
              </BreadcrumbCurrent>
            ) : (
              <BreadcrumbLink as={Link} to={item.path}>
                {isHome && <HomeIcon />}
                {item.label}
              </BreadcrumbLink>
            )}
          </React.Fragment>
        );
      })}
    </Breadcrumb>
  );
};

Breadcrumbs.displayName = "Breadcrumbs";

export default React.memo(Breadcrumbs);